<!-- BlankLayout.vue -->
<template>
  <div v-if="popupTitle && !customHeader" :class="{ 'popup-header': !infoMessage, 'tit': true }">
      <h1>{{ popupTitle }}</h1>
    </div>
  <div v-if="customHeader" id="popup-header-slot" class="tit"></div>
  <div v-if="infoMessage" class="info">
    <span class="caution type1 ml10">
      <i class="ri-information-2-fill fc06"></i>
    <span class="info-text">{{infoMessage}}</span>
    </span>
  </div>
  <div :class="{ 'wrapper': !isLoginPage }">
    <slot/>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

defineOptions({ name: 'BlankLayout' })

const route = useRoute()

const popupTitle = computed(() => route.query.popupTitle || '')
const customHeader = computed(() => route.query.customHeader === 'true')
const infoMessage = computed(() => route.query.infoMessage || '')
const isLoginPage = computed(() => route.path === '/login')
</script>
<style scoped>
.wrapper {
  padding:24px;
}
    
.popup-header {
  margin-bottom:12px;
}

.tit {padding:16px 30px; background:#004fa2; display:flex; justify-content:space-between; align-items:center;}
.tit h1 {font-size:22px; color:#fff;}
.info {padding: 12px 30px; background: #e7e7e7;}

.caution {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}

.caution i {
  flex-shrink: 0;
  line-height: 1.5;
}

.info-text {
  white-space: pre-line;
}

.no-flex {
  display: block;
}

</style>